import { v4 as uuidv4 } from 'uuid';
import { crystalTypes } from '../gameConstants';

// const crystalPerOdd = {
//   [crystalTypes.crystal_blue]: 2,
//   [crystalTypes.crystal_magenta]: 3,
//   [crystalTypes.crystal_green]: 5,
//   [crystalTypes.crystal_yellow]: 60,
//   [crystalTypes.crystal_gold]: '-',
// };

export class HistoryItem {
  constructor({
    amount,
    winAmount,
    crystal,
    odd,
  } = {}) {
    this.id = uuidv4();
    this.time = new Date().toISOString();
    this.betAmount = amount;
    this.odd = (odd || 0);
    this.winAmount = winAmount;
    this.isBonus = crystal === crystalTypes.crystal_gold;
  }

  update({
    amount,
    winAmount,
    crystal,
    odd,
  } = {}) {
    this.betAmount = amount || this.betAmount;
    this.odd = odd || this.odd;
    this.winAmount = winAmount || this.winAmount;
    this.isBonus = crystalTypes[crystal] ? Number(crystal) === crystalTypes.crystal_gold : this.isBonus;
    return this;
  }

  addOdd(odd) {
    this.odd += odd;
  }
}
